import { render, staticRenderFns } from "./DevelopmentHistory.vue?vue&type=template&id=204a310a&scoped=true&"
import script from "./DevelopmentHistory.vue?vue&type=script&lang=js&"
export * from "./DevelopmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentHistory.vue?vue&type=style&index=0&id=204a310a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a310a",
  null
  
)

export default component.exports